import React from "react";

const TourismFeatures: React.FC = () => {
  return (
    <div className="flex flex-col lg:flex-row">
      <div className="lg:max-w-[22rem] w-fit pl-5">
        <h3 className="text-2xl sm:text-4xl flex-1 lg:text-5xl xl:text-6xl">
          Features That Set Us Apart
        </h3>
        <div className="border-[2px] mt-3 sm:mt-6 lg:mt-20 xl:mt-14 border-[#FF7E00]" />
      </div>
      <div className="flex-1 grid gap-10 pt-6 lg:pt-0 sm:grid-cols-2 xl:grid-cols-3">
        <div className="hidden lg:flex">{"  "}</div>
        <div className="p-5">
          <div>
            <img
              src="/tourism/tourism-feature.svg"
              alt=""
              className="w-10 h-10 lg:w-12 lg:h-12"
            />
          </div>
          <h3 className="font-medium pt-2 text-xl xl:text-3xl lg:max-w-64">
            Real-time GPS Integration
          </h3>
          <p className="pt-3 lg:text-sm">
            Navigate with precision using our advanced GPS technology that
            guides users seamlessly through destinations, ensuring they never
            miss a landmark or point of interest.
          </p>
        </div>
        <div className="p-5">
          <div>
            <img
              src="/tourism/tourism-feature.svg"
              alt=""
              className="w-10 h-10 lg:w-12 lg:h-12"
            />
          </div>
          <h3 className="font-medium pt-2 text-xl xl:text-3xl lg:max-w-64">
            Offline Access for Remote Locations
          </h3>
          <p className="pt-3 lg:text-sm">
            Discover destinations like never before with interactive maps that
            showcase detailed information about prominent landmarks and hidden
            gems, making every journey insightful.
          </p>
        </div>
        <div className="p-5">
          <div>
            <img
              src="/tourism/tourism-feature.svg"
              alt=""
              className="w-10 h-10 lg:w-12 lg:h-12"
            />
          </div>
          <h3 className="font-medium pt-2 text-xl xl:text-3xl lg:max-w-64">
            Interactive Maps & Landmark Highlights
          </h3>
          <p className="pt-3 lg:text-sm">
            Discover destinations like never before with interactive maps that
            showcase detailed information about prominent landmarks and hidden
            gems, making every journey insightful.
          </p>
        </div>
        <div className="p-5">
          <div>
            <img
              src="/tourism/tourism-feature.svg"
              alt=""
              className="w-10 h-10 lg:w-12 lg:h-12"
            />
          </div>
          <h3 className="font-medium pt-2 text-xl xl:text-3xl lg:max-w-64">
            Bluetooth Beacon Support for Location
          </h3>
          <p className="pt-3 lg:text-sm">
            Enhance your touring experience with Bluetooth-enabled beacons that
            provide real-time, location-specific audio and visual guides for a
            fully immersive experience.
          </p>
        </div>
        <div className="p-5 flex xl:items-end">
          <img src="/tourism/features.png" alt="" className="w-full" />
        </div>
      </div>
    </div>
  );
};

export default TourismFeatures;
